const storeKeys = ['application', 'api'];

export default storeKeys;
